import React, { useState } from 'react';
import { get } from 'lodash';
import { CloudDownload } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';

import ChargersTask from '../../../resources/ChargersTask';

import { ActionWrap } from './style';
import { makeErrorHandler } from '../../../resources/helper';

function DownloadTaskAction(props) {
  const { task, alert } = props;
  const [state, setState] = useState({ loading: false });
  const { loading } = state;

  const click = () => {
    if (!loading) {
      setState({ loading: true });
      ChargersTask
        .download({ chargerId: task.chargerUuid, taskId: task.uuid })
        .then((response) => {
          const url = get(response, 'data.downloadUrl');

          if (url) {
            window.location.href = url;
          } else {
            alert('The file can not be downloaded, the given URL is wrong');
          }
        })
        .catch(makeErrorHandler(alert, { 400: 'The file can not be downloaded' }))
        .finally(() => setState({ loading: false }));
    }
  };

  return (
    <ActionWrap
      onClick={click}
      className={`link ${loading ? 'busy' : ''}`}
    >
      <CircularProgress size={10} />
      <CloudDownload />
      {' '}
      Download
    </ActionWrap>
  );
}

export default DownloadTaskAction;
